module.exports = __webpack_public_path__ + "static/media/SellerboxGuideOrder.ad758741.png";